import Header from "../../components/Header/Header";
import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./News.sass";

function slugify(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

const NewsPreview = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch('/static/news/news.json');
        if (!response.ok) {
          throw new Error('Failed to fetch news');
        }
        const data = await response.json();
        
        // Find the news item by slugified title
        const newsItem = data.find(item => slugify(item.title) === id);
        
        if (!newsItem) {
          throw new Error('News article not found');
        }
        
        setNews(newsItem);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [id]);

  if (loading) return <div className="news-loading">Loading...</div>;
  if (error) return <div className="news-error">Error: {error}</div>;
  if (!news) return <div className="news-error">Article not found</div>;

  return (
    <div className="news-preview">
      <Header />
      <div className="news-preview-container">
        <div className="news-preview__navigation">
          <Link to="/aktualnosci" className="news-preview__back">
            ← Powrót do aktualności
          </Link>
        </div>
        
        <article className="news-preview__article">
          <header className="news-preview__header">
            <h1 className="news-preview__title">{news.title}</h1>
            <p className="news-preview__date">
              {new Date(news.date).toLocaleDateString('pl-PL', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </header>
          
          {news.titleImage && (
            <div className="news-preview__image-container">
              <img 
                src={news.titleImage} 
                alt={news.title} 
                className="news-preview__image" 
              />
            </div>
          )}
          
          <div 
            className="news-preview__content" 
            dangerouslySetInnerHTML={{ __html: news.content }} 
          />
        </article>
      </div>
    </div>
  );
};

export default NewsPreview;